<template>
  <div class="main">
    <Header
      :show="true"
      title="访客"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <!-- <van-notice-bar
        left-icon="info-o"
        color="#ed6a0c"
        background="#FFFBE8"
        text="预约需要提取您的个人信息，请您放心我们将严格保护"
      /> -->

      <van-form
        ref="order"
        @submit="submit"
      >
        <van-field
          v-model.trim="listQuery.supplier"
          :disabled="listQuery.lockSupplier"
          name="供应商"
          label="供应商"
          placeholder="请输入供应商"
          :maxlength="30"
          required
        />
        <van-field
          v-model.trim="listQuery.plateNumber"
          name="车牌号"
          label="车牌号"
          placeholder="请输入货车的车牌号"
          :maxlength="10"
          required
          :rules="[
            { required: true, message: '请输入车牌号' },
            { validator: validPlateNumber, message: '车牌号格式错误' },
          ]"
        />
        <van-field
          readonly
          clickable
          name="picker"
          :value="listQuery.material"
          label="物料"
          placeholder="点击选择物料"
          required
          :rules="[{ required: true, message: '请选择物料' }]"
          @click="material.show = true"
        />
        <van-popup
          v-model="material.show"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="material.supplierMaterial"
            @confirm="handleMaterialSelect"
            @cancel="material.show = false"
          />
        </van-popup>

        <van-field
          v-if="listQuery.materialType === 2"
          name="三证合一"
          label="三证合一"
          required
        >
          <template #input>
            <van-uploader
              v-model="listQuery.photo"
              :max-count="1"
              :before-read="beforeRead"
              :after-read="afterRead"
            />
          </template>
        </van-field>
        <van-field
          v-if="listQuery.materialType === 1"
          name="磅单照片"
          label="磅单照片"
        >
          <template #input>
            <van-uploader
              v-model="listQuery.photo"
              :max-count="1"
              :before-read="beforeRead"
              :after-read="afterRead"
            />
          </template>
        </van-field>
        <div style="margin: 16px">
          <van-button
            round
            block
            type="info"
            :disabled="waiting"
            @click="handleConfirm"
          >
            确定
          </van-button>
        </div>
      </van-form>
    </div>

    <Footer
      :show="false"
      value="dashboard"
    />
  </div>
</template>

<script>
import * as imageConversion from "image-conversion";
import { parseTime } from "@/utils";
import { mapGetters } from "vuex";
import Header from "@/views/components/header/index.vue";
import { showPhoneAlarm } from "@/global/function.js";
import {
  isPlateNumber,
  isPhone,
  isNickName,
  isSupplierName,
} from "@/utils/validate";
import { createTruckOrderInfo, createCarOrderInfo } from "@/api/order.js";
import { getList as getMaterialList } from "@/api/material.js";
import { getList as getSupplierList } from "@/api/supplier.js";
import { upload } from "@/api/oss.js";

export default {
  name: "DashboardOrderCar",
  components: {
    Header,
  },
  props: {},
  data() {
    const EDate = parseTime(new Date(), "{y}/{m}/{d}");
    const SDate = EDate;
    return {
      loading: false,
      waiting: false,
      listQuery: {
        lockSupplier: false,
        name: "",
        phone: "",
        plateNumber: "",
        reason: "",
        material: "",
        materialType: undefined,
        supplier: "",
        start: SDate,
        end: EDate,
        stay: 1,
        validEnable: 0,
      },
      start: {
        show: false,
      },
      end: {
        show: false,
      },
      material: {
        show: false,
        supplierMaterial: [],
        materialList: [],
      },
      truckType: {
        show: false,
        columns: ["骨料货车", "罐装货车", "其他车辆"],
      },
    };
  },
  computed: {
    ...mapGetters({
      name: "user/name",
    }),
  },
  created() {
    const name = this.name;
    if (name !== "" && name !== null) {
      this.listQuery.supplier = name;
      this.listQuery.lockSupplier = true;
    }
    this.handleGetSupplierList();
    this.handleGetMaterialList();
  },
  methods: {
    handleClickLeft() {
      // this.$router.go(-1)
      this.$router.push({ path: "/dashboard/order", query: {} });
    },
    handleClickRight() {},
    async handleGetMaterialList() {
      const data = {
        page: 1,
        limit: 10000,
      };

      const { data: resdata } = await getMaterialList(data);
      if (
        !!resdata.data &&
        Array.isArray(resdata.data.items) &&
        resdata.data.items.length > 0
      ) {
        this.material.materialList = resdata.data.items;
      }
    },
    handleMaterialSelect(value) {
      const selectMaterial = this.material.materialList.find(
        (item) => item.name === value
      );
      if (!selectMaterial) {
        this.$toast.fail("未查询到对应的物料信息，请联系管理人员");
        return;
      }

      this.listQuery.materialType = selectMaterial.type;
      this.listQuery.material = value;
      this.material.show = false;
    },
    validPlateNumber(value) {
      return new Promise((resolve) => {
        const result = isPlateNumber(value, 2, 20);
        if (result === true) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    async handleGetSupplierList() {
      const data = {
        page: 1,
        limit: 10,
        name: this.name,
      };
      const { data: resdata } = await getSupplierList(data);
      if (
        !!resdata.data &&
        Array.isArray(resdata.data.items) &&
        resdata.data.items.length > 0
      ) {
        const [supplier] = resdata.data.items;
        this.material.supplierMaterial = supplier.materialName;
      }
    },
    beforeRead(file) {
      const allowType = ["image/png", "image/jpeg"];
      if (!allowType.includes(file.type)) {
        this.$toast("请上传jpg/png格式图片");
        return false;
      }
      return true;
    },
    afterRead(file) {
      const that = this;
      return new Promise((resolve, reject) => {
        let isLt2M = file.file.size / 1024 / 1024 < 0.2; // 判定图片大小是否小于4MB

        if (isLt2M) {
          upload(file.file).then(({ data }) => {
            that.listQuery.pictureUrl = data.data.url;
            this.listQuery.photo = [{ url: data.data.url }];
            resolve(file);
          });
        } else {
          const scale = parseFloat(
            1 / (file.file.size / 1024 / 1024 / 0.2)
          ).toFixed(2);
          imageConversion
            .compressAccurately(file.file, {
              size: 180,
              // scale: scale,
              width: 1280,
            })
            .then(async (res) => {
              upload(res, file.file.name).then(({ data }) => {
                that.listQuery.pictureUrl = data.data.url;
                this.listQuery.photo = [{ url: data.data.url }];
                resolve(file);
              });
            });
        }
      });
    },
    handleConfirm() {
      this.$refs.order.submit();
    },
    submit() {
      const payload = {
        // 必要的数据
        plateNumber: this.listQuery.plateNumber, // 车牌号
        materialName: this.listQuery.material, // 物料名称
        materialType: this.listQuery.materialType, // 物料类型编号
        supplierName: this.listQuery.supplier, // 供应商名称
        // 其他数据
        truckType: this.truckType.columns[this.listQuery.materialType - 1], // 货车类型
        pictureUrl: this.listQuery.pictureUrl, // 三证合一照片
        samplePictureUrl: this.listQuery.pictureUrl, // 磅单照片
        // 非必要数据
        name: this.listQuery.name, // 司机姓名
        phone: this.listQuery.phone, // 联系电话
        reason: this.listQuery.reason, // 进场原因
        startDate: new Date(this.listQuery.start).getTime(), // 进场开始时间
        endDate: new Date(this.listQuery.end).getTime(), // 进场结束时间
      };

      if (payload.pictureUrl && payload.truckType === "骨料货车") {
        payload.pictureUrl = "";
      }
      if (payload.samplePictureUrl && payload.truckType === "罐装货车") {
        payload.samplePictureUrl = "";
      }
      if (!payload.pictureUrl && payload.truckType === "罐装货车") {
        this.$toast.fail("请上传三证合一照片");
        return;
      }

      this.waiting = true;

      createTruckOrderInfo(payload)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              true,
              "toast",
              null,
              2000,
              data.code,
              "预约",
              data.message
            )
          ) {
            this.$router.push({ path: "/dashboard/order", query: {} });
          }
        })
        .finally(() => {
          this.waiting = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
::v-deep .van-field__label {
  width: 5em;
}
::v-deep .van-checkbox {
  padding: 3px 0;
}
::v-deep .van-checkbox__icon {
  font-size: 4.5vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
